<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
/**
 * 模块说明 多数据柱状图非重叠Eachart
 * @module Lines
 * param Object LinesList {creators,info,newdata,times}
 */

import * as echarts from "echarts"; // echarts theme
import resize from "./mixins/resize";
require("echarts/theme/macarons");

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart"
    },
    offset: {
      type: Number,
      default: 40
    },
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "100%"
    },
    LinesList: {
      type: Object,
      require: true
    },
    tit: {
      type: String
    }
  },
  watch: {
    LinesList: {
      deep: true,
      handler(val) {
        this.initChart();
      }
    }
  },
  data() {
    return {
      chart: null
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, "macarons");
      if (!Object.keys(this.LinesList).length) {
        return;
      }
      const data = this.LinesList;
      if (data.times[data.times.length - 1] === "2020") {
        data.times = data.times.slice(0, data.times.length - 1);
      }
      this.chart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          data: data.times
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "value"
        },
        yAxis: {
          type: "category",
          data: data.info,
          offset: this.offset,
          axisLabel: {
            textStyle: {
              align: "left"
            },
            formatter: function(value, index) {
              if (value.length > 12) {
                var str = value;
                var newStr = str.slice(0, 12) + " \n" + str.slice(12);
                return newStr;
              } else {
                return value;
              }
            }
          }
        },
        series: data.newdata.series
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Charts/LinesChart.vue